"use client";

import { useState } from "react";
import { refreshTprWorkflowProgress } from "@/configuration/groups/tpr/components/workflow-progress";
import { formatTprReferralAuthSkipToast, formatTprReferralAuthUploadToast, formatTprReferralAuthWriteToast } from "@/configuration/groups/tpr/referral-auth-instructions";
import { submitTprReferralAuthorization, uploadTprReferralAuthRequestLetter } from "@/src/actions/tpr-referral-auth";
import { useInvalidateServerComponent } from "@/src/components/server/client-provider";
import { Button } from "@/src/components/shadcn/ui/button";
import { toast } from "@/src/hooks/use-toast";
import { logger } from "@/src/lib/logging/logger";
export function TprSyncAuthButtons({
  taskId,
  enabled,
  canUploadLetter
}: {
  taskId: string;
  enabled: boolean;
  canUploadLetter: boolean;
}) {
  const [isWritingAuth, setIsWritingAuth] = useState(false);
  const [authWritten, setAuthWritten] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [letterUploaded, setLetterUploaded] = useState(false);
  const invalidateInstructions = useInvalidateServerComponent("getReferralInstructions");
  const handleWriteAuthorization = async () => {
    setIsWritingAuth(true);
    try {
      const result = await submitTprReferralAuthorization({
        taskId
      });
      refreshTprWorkflowProgress(invalidateInstructions);
      if (result.kind === "skipped") {
        toast(formatTprReferralAuthSkipToast(result.reason));
        return;
      }
      setAuthWritten(true);
      toast(formatTprReferralAuthWriteToast(result.write, result.alreadyExisted));
    } catch (error) {
      logger.error("Failed to submit TPR referral authorization from sync screen", {
        error,
        taskId
      });
      toast({
        title: "Could not submit authorization",
        description: error instanceof Error ? error.message : "Could not write the authorization to Athena.",
        variant: "destructive"
      });
    } finally {
      setIsWritingAuth(false);
    }
  };
  const handleUploadLetter = async () => {
    setIsUploading(true);
    try {
      const result_0 = await uploadTprReferralAuthRequestLetter({
        taskId
      });
      if (result_0.uploaded) {
        setLetterUploaded(true);
        refreshTprWorkflowProgress(invalidateInstructions);
      }
      toast(formatTprReferralAuthUploadToast(result_0.uploaded));
    } catch (error_0) {
      logger.error("Failed to upload TPR referral-auth request letter from sync screen", {
        error: error_0,
        taskId
      });
      toast({
        title: "Could not upload request letter",
        description: error_0 instanceof Error ? error_0.message : "Could not upload the request letter to Athena.",
        variant: "destructive"
      });
    } finally {
      setIsUploading(false);
    }
  };
  return <div className="flex flex-col gap-2 sm:flex-row">
      <Button size="sm" className="flex-1" disabled={!enabled || isWritingAuth || authWritten} onClick={handleWriteAuthorization} variant="outline">
        {isWritingAuth ? "Writing..." : "Referral Authorization"}
      </Button>
      <Button size="sm" className="flex-1" disabled={!enabled || !canUploadLetter || isUploading || letterUploaded} onClick={handleUploadLetter} variant="outline">
        {isUploading ? "Uploading..." : "Upload request letter"}
      </Button>
    </div>;
}